/**
 * Accent set for the "za terapeute" landing page: the consulting-room palette
 * (clay, sage, ochre, moss) that the page's hero ground and CSS tokens in
 * `src/index.css` are built from. Decoration only — `fg` is safe for icons and
 * large display numerals, not for body-size readable text.
 */
export type Accent = { fg: string; bg: string; soft: string };

export const ACCENTS: Accent[] = [
  // Clay (page accent)
  { fg: "oklch(50% 0.13 40)", bg: "oklch(50% 0.13 40 / 0.13)", soft: "oklch(50% 0.13 40 / 0.07)" },
  // Sage
  { fg: "oklch(46% 0.085 148)", bg: "oklch(46% 0.085 148 / 0.14)", soft: "oklch(46% 0.085 148 / 0.07)" },
  // Ochre
  { fg: "oklch(58% 0.11 75)", bg: "oklch(58% 0.11 75 / 0.16)", soft: "oklch(58% 0.11 75 / 0.08)" },
  // Moss
  { fg: "oklch(50% 0.07 115)", bg: "oklch(50% 0.07 115 / 0.14)", soft: "oklch(50% 0.07 115 / 0.07)" },
];

export const accentAt = (i: number): Accent => ACCENTS[i % ACCENTS.length]!;
